module.exports = __webpack_public_path__ + "img/Group 97843.2c2b03eb.png";